import type { CloudUploadScope } from 'api/apiCloudflare';
import { normalizeFolderPath } from './folderTree';

type ScopeKind =
    | 'avatar'
    | 'payment'
    | 'product'
    | 'service'
    | 'object'
    | 'event'
    | 'lead'
    | 'task'
    | 'task-template'
    | 'tool'
    | 'tool-transfer'
    | 'tool-calibration'
    | 'client-customer'
    | 'vendor-customer'
    | 'vendor'
    | 'entity';

const SCOPE_KIND_BY_KEY: { key: keyof CloudUploadScope; kind: Exclude<ScopeKind, 'entity'> }[] = [
    { key: 'avatarId', kind: 'avatar' },
    { key: 'paymentId', kind: 'payment' },
    { key: 'productId', kind: 'product' },
    { key: 'serviceId', kind: 'service' },
    { key: 'objectId', kind: 'object' },
    { key: 'eventId', kind: 'event' },
    { key: 'leadId', kind: 'lead' },
    { key: 'taskId', kind: 'task' },
    { key: 'taskTemplateId', kind: 'task-template' },
    { key: 'toolId', kind: 'tool' },
    { key: 'toolTransferId', kind: 'tool-transfer' },
    { key: 'toolCalibrationId', kind: 'tool-calibration' },
    { key: 'clientCustomerId', kind: 'client-customer' },
    { key: 'vendorCustomerId', kind: 'vendor-customer' },
    { key: 'vendorId', kind: 'vendor' },
];

interface ResolvedCloudUploadScope {
    kind: ScopeKind;
    entityId: number;
}

export const resolveCloudUploadScope = (scope: CloudUploadScope): ResolvedCloudUploadScope => {
    for (const { key, kind } of SCOPE_KIND_BY_KEY) {
        const entityId = Number(scope[key] || 0);
        if (entityId > 0) return { kind, entityId };
    }
    return { kind: 'entity', entityId: 0 };
};

export const getScopeEntityId = (scope: CloudUploadScope): number => resolveCloudUploadScope(scope).entityId;

export const getGalleryId = (scope: CloudUploadScope, currentPath = ''): string => {
    const { kind, entityId } = resolveCloudUploadScope(scope);
    const pathPart = normalizeFolderPath(currentPath).replace(/\//g, '--');
    return `files-${kind}-${entityId || 'new'}${pathPart ? `-${pathPart}` : ''}`;
};
